var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriorityLow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.912 4.76234C14.587 4.43734 14.062 4.43734 13.737 4.76234L10.5037 7.98734L7.26201 4.754C6.93701 4.429 6.41201 4.429 6.08701 4.754C5.76201 5.079 5.76201 5.604 6.08701 5.929L9.91201 9.754C10.237 10.079 10.762 10.079 11.087 9.754L14.912 5.929C15.237 5.61234 15.237 5.08734 14.912 4.76234Z",
    fill: "#4573D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.912 10.254C14.587 9.929 14.062 9.929 13.737 10.254L10.5037 13.479L7.27035 10.2457C6.94535 9.92067 6.42035 9.92067 6.09535 10.2457C5.77035 10.5707 5.77035 11.0957 6.09535 11.4207L9.92035 15.2457C10.2453 15.5707 10.7703 15.5707 11.0953 15.2457L14.9203 11.4207C15.237 11.104 15.237 10.579 14.912 10.254Z",
    fill: "#4573D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityLow);
export default __webpack_public_path__ + "static/media/priority_low.25d5909f2bc5e890cd0a29f23c3c919d.svg";
export { ForwardRef as ReactComponent };